<template>
  <!-- 经信厅的版本需要去掉header -->
  <div class="header-layout" v-if="$appTarget !== 'jxt'">
    <div>
      <!-- <div class="header-container">
        <div class="zwfw-box">
          <a
            class="outside-logo-box"
            href="https://www.zjzwfw.gov.cn/zjservice/front/index/page.do?webId=1"
            target="_blank"
          >
            <img src="@/assets/images/outside/ZJSRMZF-logo.png" />
          </a>
          <div class="apply-plat-form-title">
            <img
              v-if="isZheZhiDai"
              alt="浙江知识产权在线"
              src="@/assets/images/outside/zjzscqzx-font.png"
            />
            <img
              v-else-if="isApplyPlatform"
              alt="浙江省企业综合服务平台"
              src="@/assets/images/outside/outside-logo.png"
            />
            <img v-else alt="浙里金融" src="@/assets/images/outside/zljr-font.png" />
          </div>
        </div>
        <img
          v-if="isZheZhiDai || isApplyPlatform"
          alt="浙里金融"
          src="@/assets/images/outside/zljr-font.png"
        />
        <img v-else alt="全国信易贷平台" src="@/assets/images/outside/QGXYPT-logo.png" />
        <span class="cniil-wza"><a href="javascript:void(0)" id="cniil_wza">无障碍浏览</a></span>
      </div> -->
      <div class="header-container header-info" style="height: 80px">
        <div class="zwfw-box">
          <span class="zwfw-box__area" @click="isAreaDialogShow = true">
            {{ location }}
            <i class="el-icon-arrow-down el-icon--right" :class="{ 'rotate-icon': isAreaDialogShow }"></i>
          </span>
          <span :class="{ 'is-active': $route.path === '/' }">
            <router-link to="/">首页</router-link>
          </span>
          <span :class="{ 'is-active': ~$route.path.indexOf('product') }">
            <router-link to="/product">金融产品</router-link>
          </span>
        </div>
        <div class="user-name-box">
          <MobileAppEnterence />
          <dropdown-box :text="'我的账户'" :class="{ 'is-focus': ~$route.path.indexOf('/my') }">
            <ul class="header__dropdown-menu" slot="menu">
              <li @click="handleDropdownClick('/my/loan')">我的贷款</li>
              <li v-if="!isPerson" @click="handleDropdownClick('/my/info')">企业信息</li>
              <li @click="handleDropdownClick('/my/message')">消息中心</li>
              <li v-if="isShowLogoutBtn" class="header__dropdown-menu__logout" @click="logout">
                退出登录
              </li>
            </ul>
          </dropdown-box>
          <!-- <span class="style-ui-btn" @click="handleChangeUi" v-if="isElder">退出老年版</span>
          <span class="style-ui-btn" @click="handleChangeUi" v-else>进入老年版</span> -->
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="isAreaDialogShow" destroy-on-close>
      <AreaSelector @enter="isAreaDialogShow = false" @cancel="isAreaDialogShow = false" />
    </el-dialog>
  </div>
</template>

<script>
import MobileAppEnterence from './components/mobileAppEnterence'
import AreaSelector from '../AreaSelector'
import DropdownBox from '../DropdownBox'
import { mapState } from 'vuex'
// import { logout } from '@/api/user'
import { handleLogout } from '@/utils/common'
export default {
  components: {
    MobileAppEnterence,
    AreaSelector,
    DropdownBox
  },
  data() {
    return {
      isAreaDialogShow: false
    }
  },
  // mounted() {
  //   this.handleChangeUi()
  // },
  computed: {
    isPerson() {
      return this.$store.state.user.userType === '个体工商户'
    },
    userName() {
      return this.userInfo ? this.userInfo.username : ''
    },
    location() {
      const { city, district } = this.cityInfo
      return Array.from(new Set([city?.name, district?.name])).filter(Boolean).join(' ') || '浙江'
    },
    isShowLogoutBtn() {
      return this.ticket || this.token
    },
    // 来自经信厅则展示对应 logo
    isApplyPlatform() {
      return +sessionStorage.getItem('applyPlatform') === 1
    },
    // 浙知贷
    isZheZhiDai() {
      return +sessionStorage.getItem('applyPlatform') === 4
    },
    // 老年版
    isElder() {
      // console.log(' this.$store.state.user.uiStyle',  this.$store.state.user.uiStyle)
      return this.$store.state.user.uiStyle === 'elder'
    },
    ...mapState('user', {
      userInfo: (state) => state.userInfo,
      ticket: (state) => state.ticket,
      token: (state) => state.token,
      cityInfo: (state) => state.cityInfo
    })
  },
  methods: {
    handleDropdownClick(path) {
      this.$router.push(path)
    },
    async logout() {
      const ID = sessionStorage.getItem('applyPlatform')
      if (parseInt(ID) === 3) {
        let url =
          'https://detest.jxt.zj.gov.cn/zlb_login_api/idass/user/loginOut?redirect_url=https%3A%2F%2Fdetest.jxt.zj.gov.cn%2Fweb-company-pc-v1%2Findex.html'
        if (['prod', 'prodMicroApp'].includes(process.env.VUE_APP_ENV)) {
          url =
            'https://de-pc.jxt.zj.gov.cn/zlb_login_api/idass/user/loginOut?redirect_url=https%3A%2F%2Fde-pc.jxt.zj.gov.cn%2Fweb-company-pc-v1%2Findex.html'
        }
        window.location.href = url
        return
      }
      handleLogout(true)
      // this.$router.push('/login')
    }

  }
}
</script>

<style lang="scss" scoped>
.header-layout {
  background: white;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  position: relative;

  /deep/ .el-dialog {
    width: 700px;
  }

  // &::after {
  //   position: absolute;
  //   top: $header-height;
  //   left: 0;
  //   content: '';
  //   clear: both;
  //   background-color: #e5e5e5;
  //   height: 1px;
  //   width: 100%;
  // }
}

.header-container {
  @include text-24-400;
  @include common-layout;
  display: flex;
  height: $header-height;
  margin: 0 auto;
  font-size: 20px;
  align-items: center;
}

.zwfw-box {
  flex: 1;
  @include displayCenter($justify-content: flex-start);

  .zwfw-icon-text-box {
    // border-right: 1px solid rgba(231, 231, 231, 1);
    cursor: pointer;
  }

  &>span {
    margin-left: 30px;

    &>a {
      color: $primary-text-color;
      text-decoration: none;
    }

    &.is-active>a {
      color: $main-color;
    }

    &:hover>a {
      color: $main-color;
    }
  }

  &__area {
    // font-size: 16px;
    margin-left: 0 !important;
    cursor: pointer;

    &:hover {
      color: $main-color;
    }

    & i {
      transition: transform 0.2s;

      &.rotate-icon {
        transform: rotate(180deg);
      }
    }
  }
}

.cniil-wza {
  font-size: 20px;
  padding-left: 30px;

  a {
    text-decoration: none;
    color: #333;
  }
}

.outside-logo-box {
  position: relative;
  padding-top: 6px;
  margin-right: 20px;
  padding-right: 10px;

  img {
    height: 75px;
  }
}

.apply-plat-form-title {
  display: flex;
  align-items: center;
}

.user-name-box {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-right: -15px;

  span {
    font-size: 24px;
    color: $primary-text-color;
    line-height: 28px;
    cursor: pointer;

    &:hover {
      color: $main-color;
    }

    &.is-active {
      color: $main-color;
    }
  }

  .header__dropdown-menu {
    list-style: none;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    padding: 0 10px;
    font-size: 16px;

    &>li~li {
      border-top: 1px solid #ddd;
    }

    &>li {
      cursor: pointer;
      padding: 15px 0;

      &:hover {
        color: $main-color;
      }
    }

    &__logout {
      &:hover {
        color: red !important;
      }
    }
  }

  .style-ui-btn {
    width: 180px;
    height: 48px;
    background: #ec940e;
    border-radius: 4px;
    font-size: 26px;
    text-align: center;
    line-height: 48px;
    color: #fff !important;
  }
}
</style>
<style lang="scss">
.header__dropdown-item:hover {
  background-color: #fff !important;
}
</style>
